import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RatioDataSetFieldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RatioDataSetField",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "16",
        cy: "7.83",
        r: "2.33"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "16",
        cy: "24.17",
        r: "2.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.83 14.83H3.17C2.53 14.83 2 15.35 2 16s.52 1.17 1.17 1.17h25.67c.64 0 1.17-.52 1.17-1.17s-.52-1.17-1.17-1.17Z"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.71 16.71H1a1.14 1.14 0 1 1 0-2.28h29.71a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15.86",
        cy: "4.71",
        r: "1.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 7.57a2.86 2.86 0 1 1-.001-5.719 2.86 2.86 0 0 1 .001 5.719m0-3.43a.57.57 0 1 0 0 1.14.57.57 0 0 0 0-1.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15.86",
        cy: "26.43",
        r: "1.71"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 29.28a2.86 2.86 0 1 1-.001-5.719 2.86 2.86 0 0 1 .001 5.719m0-3.42a.57.57 0 1 0 0 1.14.57.57 0 0 0 0-1.14"
      })]
    })
  }));
};
RatioDataSetFieldIcon.displayName = 'RatioDataSetFieldIcon';